import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

/*
 * Vite inlines import.meta.env.* at build time, so a variable that is missing or
 * misnamed wherever the build runs is baked into the bundle as `undefined` and
 * the build still succeeds. Firebase then fails only at the point of use, which
 * can be a long way from the cause: a missing authDomain leaves an existing
 * session working perfectly and breaks nothing until someone clicks "Login With
 * Google". Check the config on import instead, so a misconfigured deploy fails
 * on first page load and names the variable to fix.
 */
const firebaseEnv = {
  VITE_FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
  VITE_FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  VITE_FIREBASE_DATABASE_URL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  VITE_FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  VITE_FIREBASE_MESSAGING_SENDER_ID: import.meta.env
    .VITE_FIREBASE_MESSAGING_SENDER_ID,
  VITE_FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID
};

const missingFirebaseEnv = Object.keys(firebaseEnv).filter(
  name => !firebaseEnv[name as keyof typeof firebaseEnv]
);

if (missingFirebaseEnv.length > 0) {
  throw new Error(
    `Firebase configuration is incomplete: ${missingFirebaseEnv.join(", ")} ` +
      `${missingFirebaseEnv.length === 1 ? "is" : "are"} not set. Vite inlines ` +
      `these at build time, so they must be present in the environment that ` +
      `runs the build (the Netlify project's env vars in production, .env ` +
      `locally) and the site must be rebuilt - setting them without a redeploy ` +
      `changes nothing.`
  );
}

export const firebaseApp = initializeApp({
  apiKey: firebaseEnv.VITE_FIREBASE_API_KEY,
  authDomain: firebaseEnv.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: firebaseEnv.VITE_FIREBASE_DATABASE_URL,
  projectId: firebaseEnv.VITE_FIREBASE_PROJECT_ID,
  storageBucket: firebaseEnv.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: firebaseEnv.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: firebaseEnv.VITE_FIREBASE_APP_ID,
  // Analytics only - the app works without it, so it is not required above.
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
});

export const firebaseAuth = getAuth(firebaseApp);
export const firebaseGoogleAuth = new GoogleAuthProvider();
export const db = getFirestore(firebaseApp);
